import React, { useContext } from "react";
import Loadscreen from "./../common/layout/defaultPages/loadscreen";
import { AuthContext } from "../../contexts/authContext";

export const SilentRenew = () => {
  const user = useContext(AuthContext);
  user.signinSilentCallback();
  return <Loadscreen loading={true} message="Renewing log in" />;
};
